import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SalesReturnReasonApi } from '../api/sales-return-reason.api';
import { switchMap, map } from 'rxjs/operators';
import { SalesReturnReasonData, SalesReturnReason } from '../../../interfaces/masters/salesreturnreason';

@Injectable({
  providedIn: 'root'
})
export class SalesReturnReasonService extends SalesReturnReasonData{

  constructor(private api: SalesReturnReasonApi) {
    super();
  }


  list(url: string): Observable<SalesReturnReason[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<SalesReturnReason>{
      return this.api.getById(url);
  }

  create(url: string, data:SalesReturnReason): Observable<SalesReturnReason[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:SalesReturnReason): Observable<SalesReturnReason> {
    return this.api.update(url,data);
  }

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}

